import React, { useState, useEffect } from 'react'
import { connectedApiService } from 'index'
import '../assets/styles/components/dynamic-dropdown.css'

const DynamicDropdown = ({
  onChange,
  fieldValue,
  showLabel = false,
  type = 'client',
  label = 'Company',
  inputFor = 'company',
  returnId = false,
}) => {
  const [searchTerm, setSearchTerm] = useState('')
  const [options, setOptions] = useState([])
  const [companyOptions, setCompanyOptions] = useState([])
  const [filteredOptions, setFilteredOptions] = useState([])
  const [isOpen, setIsOpen] = useState(false)

  useEffect(() => {
    const fetchOptions = async () => {
      try {
        if (searchTerm.length > 2) {
          const response = await connectedApiService.get(
            `company/companyOptions/${type}/${searchTerm}`
          )
          if (response.data && response.data.companyOptions) {
            if (returnId) {
              setCompanyOptions(response.data.companyOptions)
              setOptions(
                response.data.companyOptions.map(company => company.name)
              )
            } else {
              setOptions(
                response.data.companyOptions.map(company => company.name)
              )
              setCompanyOptions([])
            }
          } else {
            setOptions([])
            setCompanyOptions([])
          }
        } else {
          setOptions([])
          setCompanyOptions([])
        }
      } catch (error) {
        console.error('Error:', error)
      }
    }
    fetchOptions()
  }, [searchTerm, returnId, type])

  useEffect(() => {
    if (fieldValue === '') {
      setSearchTerm('')
    }
  }, [fieldValue])

  const handleInputChange = e => {
    setSearchTerm(e.target.value)
  }

  const handleDropdownToggle = () => {
    setIsOpen(!isOpen)
  }
  const handleDropdownBlur = () => {
    if (!isOpen) {
      setIsOpen(false)
    }
  }

  const handleOptionSelect = option => {
    setSearchTerm(option)
    setFilteredOptions([])
    setIsOpen(false)

    if (returnId && companyOptions.length > 0) {
      const selectedCompany = companyOptions.find(
        company => company.name === option
      )
      if (selectedCompany) {
        onChange({
          companyName: selectedCompany.name,
          companyId: selectedCompany._id,
        })
      } else {
        onChange(option)
      }
    } else {
      onChange(option)
    }
  }

  useEffect(() => {
    setFilteredOptions(
      options.filter(option =>
        option.toLowerCase().includes(searchTerm.toLowerCase())
      )
    )
  }, [searchTerm, options])

  return (
    <div className='searchable-dropdown'>
      {showLabel ? (
        <label class='form-label form-label' for={inputFor}>
          {label}
        </label>
      ) : (
        <></>
      )}
      <input
        type='text'
        value={searchTerm}
        onChange={handleInputChange}
        onFocus={handleDropdownToggle}
        onBlur={handleDropdownBlur}
        placeholder='Search...'
        className='search-input'
      />
      {isOpen && filteredOptions.length > 0 && (
        <ul
          className='dropdown-options'
          style={showLabel ? { zIndex: 1 } : null}
        >
          {filteredOptions.map(option => (
            <li
              key={option}
              onClick={() => {
                handleOptionSelect(option)
              }}
              tabIndex='0'
              className='dropdown-option'
            >
              {option}
            </li>
          ))}
        </ul>
      )}
    </div>
  )
}

export default DynamicDropdown
